import { PhoneNumber } from '@aviv-estimation-funnel/data-validation/phone-number';
import { RegionCode } from '@aviv-estimation-funnel/estimation-data-models/enums';

export const formatPhoneNumber = (
    phoneNumber: string | number,
    regionCode: (typeof RegionCode)[keyof typeof RegionCode],
): string => {
    return new PhoneNumber(phoneNumber.toString(), regionCode).international;
};
